







import { Vue, Component } from "vue-property-decorator";
import FullScreenLoading from "@/components/FullScreenLoading.vue";
import AuthController from "@/controller/auth";
import firebase from "firebase/app";

@Component({
  components: {
    FullScreenLoading
  }
})
export default class App extends Vue {
  isInitialized = false;

  beforeCreate() {
    const callback = (user: firebase.User | null) => this.handleAuth(user);
    AuthController.watchLoggedInState(callback);
  }

  async handleAuth(user: firebase.User | null) {
    if (user) {
      const token = await user.getIdTokenResult();
      const role = token.claims.role;

      if (!role) {
        this.redirectTo401();
        return;
      }

      this.setUserRole(role);
      this.setUserEmail(user.email as string);
      this.setUserName(user.displayName as string);

      if (this.$route.name === "Login") {
        this.$router.push({ name: "Home" });
      }

      if (this.isAdminPage()) {
        if (role !== "admin") {
          this.$router.push({ name: "Home" });
        }
      }
    } else {
      this.clearUser();

      if (this.$route.name !== "Login") {
        this.$router.push({ name: "Login" });
      }
    }

    this.isInitialized = true;
  }

  private redirectTo401() {
    if (this.$route.name !== "Page401") {
      this.$router.push({ name: "Page401" });
    }
    this.isInitialized = true;
  }

  private async setUserRole(role: string) {
    this.$store.dispatch("user/setRole", role);
  }

  private setUserEmail(email: string) {
    this.$store.dispatch("user/setEmail", email);
  }

  private setUserName(name: string) {
    this.$store.dispatch("user/setName", name);
  }

  private clearUser() {
    this.$store.dispatch("user/clearUser");
  }

  private isAdminPage() {
    const routeName = this.$route.name || "";
    return routeName.includes("Admin");
  }
}
